<template>
  <i18n-t
    data-test="low-results-dates"
    tag="p"
    :keypath="correctTranslationKey"
  >
    <template #removeDates>
      <pu-low-results-search-link
        :modify-filters="{
          dates: {},
          priceRange: {},
        }"
      >
        <translate>Remove your dates</translate>
      </pu-low-results-search-link>
    </template>
    <template #daysEarlier>
      <span data-test="low-resuts-earlier-days">
        <pu-low-results-search-link
          v-if="isFuture(-1)"
          data-test="low-results-date-1"
          :modify-filters="modifyDates(-1)"
          >1</pu-low-results-search-link
        >
        <pu-low-results-search-link
          v-if="isFuture(-2)"
          data-test="low-results-date-2"
          :modify-filters="modifyDates(-2)"
          >2</pu-low-results-search-link
        >
        <pu-low-results-search-link
          v-if="isFuture(-3)"
          data-test="low-results-date-3"
          :modify-filters="modifyDates(-3)"
          >3</pu-low-results-search-link
        >
      </span>
    </template>
    <template #daysLater>
      <pu-low-results-search-link
        data-test="low-results-date+1"
        :modify-filters="modifyDates(1)"
      >
        1
      </pu-low-results-search-link>
      <pu-low-results-search-link
        data-test="low-results-date+2"
        :modify-filters="modifyDates(2)"
      >
        2
      </pu-low-results-search-link>
      <pu-low-results-search-link
        data-test="low-results-date+3"
        :modify-filters="modifyDates(3)"
      >
        3
      </pu-low-results-search-link>
    </template>
  </i18n-t>
</template>

<script lang="ts">
import type { ArriveDepartIso } from '../../types'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { addDays } from '~/utility/date/relative'

@Component
class LowResultsDates extends Vue {
  @Prop()
  dates: ArriveDepartIso

  modifyDates(days) {
    return {
      dates: this.changeDateRangeByDays(days),
    }
  }

  get correctTranslationKey() {
    if (!this.isFuture(-1)) {
      return 'Low results modify dates by - future'
    }
    return 'Low results modify dates by'
  }

  isFuture(modificator: number): boolean {
    const date = new Date(this.dates.arrive)
    date.setDate(date.getDate() + modificator)
    return date.setHours(0, 0, 0, 0) >= new Date().setHours(0, 0, 0, 0)
  }

  changeDateRangeByDays(days): ArriveDepartIso {
    const dateRange = this.getDateRangeModifiedByDates(days)
    return {
      arrive: dateRange.arrive,
      depart: dateRange.depart,
    }
  }

  private getDateRangeModifiedByDates(days) {
    return {
      arrive: addDays(days, this.dates.arrive),
      depart: addDays(days, this.dates.depart),
    }
  }
}

export default toNative(LowResultsDates)
</script>
